import "../../sessions/redesign.css";
import { Link } from "react-router-dom";

const RedesignFooter = () => (
  <footer className="tt-footer">
    <div className="tt-wrap">
      <div className="tt-footer__grid">
        <div className="tt-footer__brand">
          <img src="/assets/logo3.svg" alt="TimeTango" style={{height:28}} />
          <p>All-in-one employee attendance, activity tracking, leave management and HRMS platform — synced across desktop, web and mobile.</p>
        </div>
        <div className="tt-footer__col">
          <h3>Solutions</h3>
          <Link to="/solutions/attendance">Attendance Management</Link>
          <Link to="/solutions/leave">Leave Management</Link>
          <Link to="/solutions/activity-tracking">Activity Tracking</Link>
          <Link to="/solutions/timesheet">Timesheet & Approval</Link>
          <Link to="/solutions/visitor">Visitor Management</Link>
        </div>
        <div className="tt-footer__col">
          <h3>Company</h3>
          <Link to="/about-us">About Us</Link>
          <Link to="/blogs">Blog</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/contact-us">Contact Us</Link>
        </div>
        <div className="tt-footer__col">
          <h3>Get Started</h3>
          <Link to="/pricing">Pricing</Link>
          <Link to="/company-register">Free Trial</Link>
          <Link to="/login">Login</Link>
          <a href="https://calendly.com/amol-amlapure" target="_blank" rel="noreferrer">Schedule a Demo</a>
        </div>
      </div>
      <div className="tt-footer__bottom">
        <span>&copy; {new Date().getFullYear()} TimeTango by Gunadhya Software Solutions Pvt. Ltd.</span>
        <div style={{display:"flex",gap:16}}>
          <a href="https://www.facebook.com/profile.php?id=61550584126267" target="_blank" rel="noreferrer">Facebook</a>
          <a href="https://www.linkedin.com/showcase/99884387/" target="_blank" rel="noreferrer">LinkedIn</a>
          <a href="https://www.instagram.com/timetango.in/" target="_blank" rel="noreferrer">Instagram</a>
        </div>
      </div>
    </div>
  </footer>
);

export default RedesignFooter;
